<div class="content-center p-4">
  <app-loading-indicator />
</div>
